import { nodeComponentRegistry } from '../../../r3f/NodeComponentRegistry';
import { Polygon2D } from './Component';
nodeComponentRegistry.register({ typeName: 'Polygon2D', Component: Polygon2D, canvasItem: true });
//# sourceMappingURL=index.r3f.js.map